/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_PermissionUser,
  EnumerableCommandResult_PermissionUser,
  ListCommandResult_PermissionUser
} from "@graphql/helpers/types.graphql";
import {
  CommandResult,
  EnumerableCommandResult,
  ListCommandResult
} from "@graphql/groups/fragment.graphql";
import utils, {
  TPermissionUserType,
  TConstructionType,
  TJoin,
  TNonEmptyArray,
  TUserType,
  TContractType,
  TClientType,
  TContractSellerType,
  TSellerType,
  TModuleType,
  TConcretingType,
  TInvoiceType,
  TConcreteStrengthCertificateType
} from "@graphql/helpers/utils.graphql";

type TPermissionUserByIdFunctions = {
  getByID: CommandResult_PermissionUser;
};
export type TPermissionUserByIdQueries = {
  permissionUser: TPermissionUserByIdFunctions;
};

type TGlobal =
  | TPermissionUserType
  | TJoin<"user", TUserType>
  | TJoin<"construction", TConstructionType>
  | TJoin<"construction.client", TClientType>
  | TJoin<"contract", TContractType>
  | TJoin<"contract.contractSellers", TContractSellerType>
  | TJoin<"contract.contractSellers.seller", TSellerType>
  | TJoin<"contract.concretings", TConcretingType>
  | TJoin<"contract.construction", TConstructionType>
  | TJoin<"contract.construction.client", TClientType>
  | TJoin<
      "contract.concretings.concreteStrengthCertificates",
      TConcreteStrengthCertificateType
    >
  | TJoin<"contract.invoices", TInvoiceType>
  | TJoin<"module", TModuleType>;

export const permissionUserById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query permissionUserById($id: Guid!) {
    permissionUser {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_PermissionUser")}
`;

type TPermissionUserAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_PermissionUser;
};
export type TPermissionUserAllWithPaginationQueries = {
  permissionUser: TPermissionUserAllWithPaginationFunctions;
};
export const permissionUserAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query permissionUserAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    permissionUser {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_PermissionUser")}
`;

type TPermissionUserAllWithoutPaginationFunctions = {
  getAllWithoutPagination: EnumerableCommandResult_PermissionUser;
};
export type TPermissionAllWithoutPaginationQueries = {
  permissionUser: TPermissionUserAllWithoutPaginationFunctions;
};
export const permissionUserAllWithoutPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query permissionUserAllWithoutPagination($where: [WhereClausesInputType]) {
    permissionUser {
      getAllWithoutPagination(where: $where) {
        ...ENUMERABLE_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${EnumerableCommandResult("EnumerableCommandResult_PermissionUser")}
`;
